import { render, staticRenderFns } from "./ConsiderationsView.vue?vue&type=template&id=1771dea8&scoped=true&"
import script from "./ConsiderationsView.vue?vue&type=script&lang=js&"
export * from "./ConsiderationsView.vue?vue&type=script&lang=js&"
import style0 from "./ConsiderationsView.vue?vue&type=style&index=0&id=1771dea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1771dea8",
  null
  
)

export default component.exports